/**
 * Slug estilo GitHub/GFM para anclas de headings: sin acentos, lowercase,
 * solo a-z 0-9 y guiones. "5. Paso 3 — Abrir…" -> "5-paso-3-abrir-…".
 *
 * Compartido entre el editor de guías (al importar .md genera los id de
 * los headings) y la vista de la guía (re-deriva los id para que los
 * enlaces del índice/TOC casen). Si ambos lados no usan EXACTAMENTE el
 * mismo algoritmo, los anchors no encuentran su destino.
 */
export function slugifyHeading(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
